import Script from "next/script";

export const getPixelId = (key: string) => {
  switch (key) {
    case "shhalu-ahuja":
      return "2226502354457026";
    case "shhalu-ahuja-tarot":
      return "1910682859694709";
    case "rema-sangwan":
      return "1622975725618459";
    case "vivek-khanna":
      return "802664749303701";
    case "raunak-mishra":
      return "845421017997623";
    case "garrima-prakaesh":
      return "998516959540247";
    case "acharya-laxmi-tripathi":
      return "1177628127848371";
    case "venughopaal-nlp":
      return "2212752062795174";
    case "sandhya-k-bassi":
      return "1075355085065589";
    case "sandhya-k-bassi-vedic":
      return "1075355085065589";
    case "yogesh-daudkhane":
      return "990260543491841";
    case "gargi-dhawan-mradul":
      return "1545303483725123";
    case "pooja-dawar":
      return "1047655724478148";
    case "amritaa-shankar":
      return "1678356800528201";
    default:
      break;
  }
};

export const initPixel = (key: string) => {
  const pixelId = getPixelId(key);
  if (!pixelId) return null;
  return (
    <>
      <Script
        id={`additional-pixel-${pixelId}`}
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod ?
                n.callMethod.apply(n, arguments) : n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window,document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '${pixelId}');
            fbq('track', 'PageView');
        `,
        }}
      />
      <noscript>
        <img
          height="1"
          width="1"
          src={`https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`}
        />
      </noscript>
    </>
  );
};

export const trackPixelEvent = (
  key: string,
  event: string,
  type: "standard" | "custom" = "standard",
) => {
  const pixelId = getPixelId(key);
  if (!pixelId) return;

  console.log("trackPixelEvent called for:", pixelId, event, type);

  if (
    typeof window !== "undefined" &&
    typeof (window as any).fbq === "function"
  ) {
    if (type === "standard") {
      (window as any).fbq("trackSingle", pixelId, event);
    } else if (type === "custom") {
      (window as any).fbq("trackSingleCustom", pixelId, event);
    }
  } else {
    console.warn("fbq not found on window. Pixel event not tracked.");
  }
};
